export default __webpack_public_path__ + "static/media/Res1.b8df5490.jpeg";